module.exports = __webpack_public_path__ + "img/table-expansion-open.2a91dabe.svg";